import http from "../http-common";

class MutuoService {

    ingresar(data) {
        return http.post("/mutuo",data);
    }

    update(id_mutuo, data) {
        return http.put(`/mutuo/${id_mutuo}`,data);
    }

    getByID(id_mutuo) {
        return http.get(`/mutuo/${id_mutuo}`);
    }
}

export default new MutuoService();